import { render, staticRenderFns } from "./orderItemForm.vue?vue&type=template&id=41f1f8a2&"
import script from "./orderItemForm.vue?vue&type=script&lang=ts&"
export * from "./orderItemForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports